import type {AxiosRequestConfig} from 'axios';
import {Order, Status, CancelOrder, PayloadAllUpdate} from './interface';

export class GetAllCategoriesRequestBuilder {
  private readonly catRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/ticket-management/categories',
    params: {},
  };

  params(params: object) {
    this.catRequest.params = params;
    return this;
  }

  build() {
    return this.catRequest;
  }
}
export class GetAllOrganRequestBuilder {
  private readonly organRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/ticket-management/organizations',
    params: {},
  };

  params(params: object) {
    this.organRequest.params = params;
    return this;
  }

  build() {
    return this.organRequest;
  }
}
export class PostOrganRequestBuilder {
  private readonly organRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/ticket-management/customers',
    data: {},
  };

  data(data: object) {
    this.organRequest.data = data;
    return this;
  }

  build() {
    return this.organRequest;
  }
}
export class GetAllCustomersRequestBuilder {
  private readonly catRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/ticket-management/customers',
    params: {},
  };

  params(params: object) {
    this.catRequest.params = params;
    return this;
  }

  build() {
    return this.catRequest;
  }
}
export class GetAllTicketsRequestBuilder {
  private readonly ticketRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/ticket-management/tickets',
    params: {},
  };

  params(params: object) {
    this.ticketRequest.params = params;
    return this;
  }

  build() {
    return this.ticketRequest;
  }
}
export class GetTicketRequestBuilder {
  private readonly ticketRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };
  id(id: number) {
    this.ticketRequest.url = `/ticket-management/tickets/${id}`;
    return this;
  }
  build() {
    return this.ticketRequest;
  }
}
export class CloseTicketRequestBuilder {
  private readonly ticketRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
  };
  id(id: number) {
    this.ticketRequest.url = `/ticket-management/tickets/${id}/close`;
    return this;
  }
  build() {
    return this.ticketRequest;
  }
}
export class PostAllTicketsRequestBuilder {
  private readonly updatTicketRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/ticket-management/tickets',
    params: {},
    data: {},
  };

  params(params: object) {
    this.updatTicketRequest.params = params;
    return this;
  }

  data(body: any) {
    this.updatTicketRequest.data = body;
    return this;
  }

  build() {
    return this.updatTicketRequest;
  }
}
export class ReplyAllTicketsRequestBuilder {
  private readonly updatTicketRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/ticket-management/tickets/reply',
    params: {},
    data: {},
  };

  params(params: object) {
    this.updatTicketRequest.params = params;
    return this;
  }

  data(body: any) {
    this.updatTicketRequest.data = body;
    return this;
  }

  build() {
    return this.updatTicketRequest;
  }
}
export class FileUploadTicketsRequestBuilder {
  private readonly fileTicketRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    params: {},
    data: {},
  };

  id(id: number) {
    this.fileTicketRequest.url = `/ticket-management/tickets/${id}/upload`;
    return this;
  }

  params(params: object) {
    this.fileTicketRequest.params = params;
    return this;
  }

  data(body: any) {
    this.fileTicketRequest.data = body;
    return this;
  }

  build() {
    return this.fileTicketRequest;
  }
}
export class GetAllTicketsCountRequestBuilder {
  private readonly ticketRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/ticket-management/tickets/count',
    params: {},
  };

  params(params: object) {
    this.ticketRequest.params = params;
    return this;
  }

  build() {
    return this.ticketRequest;
  }
}
